import actions from './actions'
import getters from './getters'
import types from './types'

const state = {
  token: null,
  user: {}
}

const mutations = {
  [types.SET_TOKEN](state, token) {
    state.token = token
  },
  [types.SET_USER](
    state,
    { id, type, email, firstName, lastName, permissions }
  ) {
    state.user = {
      id,
      type,
      email,
      firstName,
      lastName,
      permissions
    }
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
